import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../../RestockingState'
import { useHistory } from 'react-router-dom'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { useBlockPopAction } from 'src/hooks/useBlockPopAction'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'
import ScanCode from 'src/features/restocking/components/RestockingWebAppForm/components/ScanCode/ScanCode'
import UserGuidance from 'src/features/restocking/components/RestockingWebAppForm/components/UserGuidance/UserGuidance'
import UserIdentifier from 'src/features/restocking/components/RestockingWebAppForm/components/UserIdentifier/UserIdentifier'
import * as S from './CollectAddressPage.styles'

interface FormData {
  addressCode: string;
}

const CollectAddressPage: React.FC = () => {
  const [addressError, setAddressError] = useState('')
  const [openModalFullCart, setOpenModalFullCart] = useState(false)
  const { register, getValues } = useForm<FormData>()
  const { user, currentCollectRestockingAddress } = useSelector((state) => state.restocking)
  const { fc, validateFc } = useFulfillmentCenter()
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  useBlockPopAction()

  const closeModalFullCart = () => setOpenModalFullCart(false)

  const navigateToCollectProduct = () => history.push('/restocking/webapp/collect-product')

  const onSuccess = () => navigateToCollectProduct()

  const sourceAddress = user.startedPage.itemsToCollect?.addresses.find((address) => !address.done)

  const onSubmit = () => {
    if (!sourceAddress) return

    if (!currentCollectRestockingAddress) {
      dispatch(actions.setProperty({
        property: 'currentCollectRestockingAddress',
        value: sourceAddress,
      }))
    }

    const addressCode = getValues('addressCode').trim()

    if (user.startedPage.itemsToCollect) {
      const onValidateAddressSuccess = () => {
        const itemsAddresses = sourceAddress.items.map((item) => ({
          idItem: item.id,
          idsItemAddress: item.itemAddress.ids,
        }))

        dispatch(actions.startRestockingAddress({
          badge: user.badge,
          itemsAddresses,
          idPage: user.startedPage.itemsToCollect!.id,
          idFulfillmentCenter: fc.id,
          onSuccess,
        }))
      }

      const idsModels = sourceAddress.items.map((item) => item.idModel)

      dispatch(actions.validateCollectAddress({
        badge: user.badge,
        idsModels,
        address: sourceAddress.address,
        addressToValidate: addressCode,
        isGondola: sourceAddress.isGondola,
        onSuccess: () => onValidateAddressSuccess(),
        setError: (error) => setAddressError(error),
      }))
    }
  }

  const onSubmitFullCart = () => {
    if (!user.startedPage.itemsToCollect) return

    dispatch(actions.restockingFullcart({
      badge: user.badge,
      idPage: user.startedPage.itemsToCollect.id,
      history,
      idsItemAddress: [],
    }))

    setOpenModalFullCart(false)
  }

  return (
    <Page headerTitle='Reposição' hasBackButton={false}>
      <S.Info>
        <UserIdentifier idPage={user.startedPage.itemsToCollect?.id}/>
        <UserGuidance text='Dirija-se para:'>
          {
          sourceAddress && (
            <Typography style={{ fontWeight: 'bold', fontSize: '30px' }}>{sourceAddress.address}</Typography>
          )
        }
        </UserGuidance>
      </S.Info>
      <S.Form>
        <ScanCode
          text='Ao chegar bipe o código do endereço.'
          onSubmit={onSubmit}
          register={register}
          dataTestId='input-address-code-test-id'
          inputName='addressCode'
          hasError={!!addressError}
          errorMessage={addressError}
        />
        <S.ContainerButton>
          <S.CustomButton
            title='Carrinho cheio'
            bgColor='orange2'
            hoverColor='orange'
            letterColor='white'
            data-testid='full-cart-button-test-id'
            onClick={() => setOpenModalFullCart(true)}
          />
        </S.ContainerButton>
      </S.Form>
      <ConfirmOrRejectModal
        show={openModalFullCart}
        title='Confirmação carrinho cheio'
        description='Confirme que o carrinho está cheio.'
        onConfirm={onSubmitFullCart}
        onReject={closeModalFullCart}
        onClose={closeModalFullCart}
        dataTestId='modal-confirmation-full-cart-test-id'
      />
    </Page>
  )
}

export default CollectAddressPage
